import React from 'react';
import { useNodeForm } from '../../../hooks/useNodeForm';
import NodeForm from './NodeForm';

const CreateNodeModal = ({ isOpen, onClose, onCreate }) => {
  const { formData, updateFormData, getFormData, resetForm } = useNodeForm();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = getFormData();
    onCreate?.(data);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Добавить новую ноду
          </h2>
          <NodeForm formData={formData} onChange={updateFormData} mode="create" />
          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border border-gray-200 dark:border-dark-800 rounded-lg text-sm font-medium text-gray-700 dark:text-dark-300 bg-white dark:bg-dark-900 hover:bg-gray-50 dark:hover:bg-dark-800 transition-colors"
            >
              Отмена
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 px-4 py-2.5 border border-transparent rounded-lg text-sm font-medium text-black bg-primary-500 hover:bg-primary-600 transition-colors"
            >
              Создать ноду
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNodeModal;